import { toFiniteNumber } from './financeGoldRate';

function norm(value) {
  return String(value || '').trim();
}

/**
 * Deterministik milyem kaynağı. Ürün adından ayar parse etmez.
 * 1) product.urunMilyem
 * 2) rule.milyemOverride
 * 3) settings.milyemByProductType[urunTipi]
 * 4) unknown
 */
export function resolveMilyem({ product, rule, settings } = {}) {
  const fromProduct = toFiniteNumber(product?.urunMilyem ?? product?.milyem);
  if (fromProduct > 0) {
    return { ok: true, milyem: fromProduct, source: 'product' };
  }

  const fromRule = toFiniteNumber(rule?.milyemOverride);
  if (fromRule > 0) {
    return { ok: true, milyem: fromRule, source: 'rule_override' };
  }

  const typeKey = norm(product?.urunTipi || product?.isim);
  const map = settings?.milyemByProductType && typeof settings.milyemByProductType === 'object'
    ? settings.milyemByProductType
    : {};
  const fromSettings = typeKey ? toFiniteNumber(map[typeKey]) : 0;
  if (fromSettings > 0) {
    return { ok: true, milyem: fromSettings, source: 'settings' };
  }

  return { ok: false, milyem: 0, source: null };
}
